import { sortByOrder } from './sorting';

type RankableOption = { name: string; order?: number; disabledForBuyer?: boolean | null; comingSoon?: boolean | null };

type RankablePrefill = { lastOrderShippingMethods?: string[] | null; prefillSources?: Record<string, string> | null } | null | undefined;

export type DeliveryRanking = { order: string[]; firstReady?: string };

const BOUGHT = 0;
const NOT_READY = 3;

/**
 * DEV-2422: the providers the buyer has bought with (most recent first), then the ones they posted
 * with as a seller, then the ones filled from their address, then the rest. Everything except the
 * first group keeps the market order. firstReady is the provider to select when nothing else is.
 */
export const rankDeliveryMethods = (
  options: RankableOption[],
  prefill: RankablePrefill,
  addressFilledMethods: string[],
  tooSmallMethods: string[],
): DeliveryRanking => {
  const boughtMethods = prefill?.lastOrderShippingMethods ?? [];
  const prefillSources = prefill?.prefillSources ?? {};
  // a seller locker the parcel doesn't fit is not filled in, so it isn't ready to go
  const soldMethods = Object.keys(prefillSources).filter(
    (method) => prefillSources[method] === 'sale' && !tooSmallMethods.includes(method),
  );
  const groups = [boughtMethods, soldMethods, addressFilledMethods];

  const groupOf = (option: RankableOption) => {
    const group = groups.findIndex((methods) => methods.includes(option.name));

    return option.disabledForBuyer || option.comingSoon || group === -1 ? NOT_READY : group;
  };

  const ranked = options
    .map((option) => ({ option, group: groupOf(option), recency: boughtMethods.indexOf(option.name) }))
    .sort((a, b) => a.group - b.group || (a.group === BOUGHT ? a.recency - b.recency : 0) || sortByOrder(a.option, b.option));

  return {
    order: ranked.map(({ option }) => option.name),
    firstReady: ranked.find(({ group }) => group !== NOT_READY)?.option.name,
  };
};
